import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '10+',
  label: 'Years of Service',
  subLabel: '十年卓越服务'
}, {
  value: '5000+',
  label: 'Satisfied Clients',
  subLabel: '尊贵客户首选'
}, {
  value: '200+',
  label: 'Elite Companions',
  subLabel: '严选顶级佳丽'
}, {
  value: '99%',
  label: 'Client Satisfaction',
  subLabel: '极致好评口碑'
}];
export function TrustSection() {
  return <section className="py-24 bg-dark-surface2 border-y border-gold-400/10" data-id="element-58">
      <div className="max-w-7xl mx-auto px-6" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-60">
          <h2 className="text-3xl md:text-4xl font-serif text-gold-100 mb-6" data-id="element-61">
            十年卓越 <span className="text-gold-400 mx-2" data-id="element-62">·</span> A Decade of
            Excellence
          </h2>
          <p className="text-gold-100/60 max-w-2xl mx-auto" data-id="element-63">
            Built on a foundation of trust, discretion, and unparalleled
            quality. We have set the standard for premium companion services in
            Singapore since 2015.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12" data-id="element-64">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="text-center relative" data-id="element-65">
              {/* Divider for desktop (except last item) */}
              {index < stats.length - 1 && <div className="hidden md:block absolute right-0 top-1/2 transform -translate-y-1/2 w-[1px] h-16 bg-gold-400/10 translate-x-6" data-id="element-66" />}

              <div className="text-4xl md:text-5xl lg:text-6xl font-serif text-gold-400 mb-2 font-bold" data-id="element-67">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-gold-100 font-medium mb-1" data-id="element-68">
                {stat.label}
              </div>
              <div className="text-xs text-gold-600 uppercase tracking-wide" data-id="element-69">
                {stat.subLabel}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}